import {COLORS, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import couponWalletBackground from '../../../features/Coupons/assets/couponWalletBackground.svg';

export const CouponSkeletons = () => {
  return (
    <Wrapper>
      <InnerWrapper>
        <Flex style={{marginBottom: '20px'}}>
          <SkeletonBlock $width="20%" $height="30px" />
          <SkeletonBlock $width="20%" $height="30px" />
        </Flex>
        <TextWrapper>
          <CouponLoader $height="42px" $width="42px" />
          <SkeletonBlock $height="20px" $width="50%" />
          <SkeletonBlock $height="54px" $width="100%" />
        </TextWrapper>
      </InnerWrapper>
      <BottomSheetWrapper>
        <CouponCard $height="164px" $width="100%" />
        <CouponCard $height="164px" $width="100%" />
        <CouponCard $height="164px" $width="100%" />
        <CouponCard $height="164px" $width="100%" />
        <CouponCard $height="164px" $width="100%" />
        <CouponCard $height="164px" $width="100%" />
      </BottomSheetWrapper>
    </Wrapper>
  );
};

const Flex = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;

const Wrapper = styled.div`
  height: 100%;
  overflow: auto;
`;

const InnerWrapper = styled.div`
  padding: 24px 16px 40px;

  background-color: ${COLORS.PrimaryCoupon};
  background-image: url(${couponWalletBackground});
  background-size: 100%;
`;

const BottomSheetWrapper = styled.div`
  margin-top: -1rem;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  background-color: ${COLORS.White};
  padding: 2rem 1rem;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 8px 8px 16px 8px;
  width: 100%;
`;

const CouponLoader = styled(SkeletonBlock)`
  border-radius: 50%;
`;

const CouponCard = styled(SkeletonBlock)`
  border-radius: 16px;
`;
